import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';
import { h500, h600, h700 } from '../styles/fonts';

// eslint-disable-next-line rulesdir/no-styled-export
export const LoginHeader = styled.div`
    ${h700}
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LoginDescription = styled.div`
    ${h600}
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LoginFormContainer = styled.div`
    margin-top: ${token('space.300', '24px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const FooterContainer = styled.div`
    margin-top: ${token('space.400', '32px')};
    text-align: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LoginAnnouncementContainer = styled.div`
    padding-bottom: ${token('space.200', '16px')};
    border-bottom: 1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LoginAnnouncementTitle = styled.div`
    ${h500}
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LoginAnnouncementBody = styled.div`
    margin-top: ${token('space.100', '8px')};
    max-width: ${grid.multiple(42).px};
    overflow-wrap: break-word;
`;
